/**
 * Get reCAPTCHA Enterprise token
 * @param {string} action - The action name (e.g., 'checkout', 'login')
 * @returns {Promise<string>} The reCAPTCHA token
 */
export const getRecaptchaToken = async (action = 'checkout') => {
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    
    if (!siteKey) {
        console.warn('reCAPTCHA site key not configured');
        return null;
    }

    if (!window.grecaptcha || !window.grecaptcha.enterprise) {
        console.error('reCAPTCHA Enterprise not loaded');
        return null;
    }

    try {
        await window.grecaptcha.enterprise.ready(() => {});
        const token = await window.grecaptcha.enterprise.execute(siteKey, { action });
        return token;
    } catch (error) {
        console.error('Error getting reCAPTCHA token:', error);
        return null;
    }
};

/**
 * Check if reCAPTCHA is enabled
 * @returns {boolean}
 */
export const isRecaptchaEnabled = () => {
    return !!process.env.REACT_APP_RECAPTCHA_SITE_KEY;
};
